"use client"
import { useAuth } from "../../context/AuthContext"
import { ButtonFluxi } from "../common/Buttons/ButtonFluxi/ButtonFluxi"
import { Button } from "../ui/button"
import { dictionary } from "../../utils/dictionary"
interface PlanChangeModalProps {
  isOpen: boolean
  onClose: () => void
  onUpgrade: () => void
  onCancel: () => void
}

export function PlanChangeModal({ isOpen, onClose, onUpgrade, onCancel }: PlanChangeModalProps) {
  if (!isOpen) return null
  const { language } = useAuth();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      <div className="relative bg-white rounded-3xl shadow-lg w-full max-w-md mx-4 p-6">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-xl font-bold"
        >
          ×
        </button>

        <div className="space-y-6">
          <h2 className="text-xl font-semibold text-center text-gray-900">Cambiar mi plan</h2>

          <p className="text-gray-600 text-center">{dictionary["what-would-you-like-to-do-with-your-current-plan"][language]}</p>

          <div className="flex items-center justify-center gap-2">
            <div className="flex items-center justify-center gap-2 w-full">
              <ButtonFluxi style={{ fontSize: "16px", paddingTop: "10px", paddingBottom: "10px", minWidth: "100%", maxHeight: "40px", width: "100%" }} onClick={onUpgrade}>
                {dictionary["improve-my-plan"][language]}
              </ButtonFluxi>
            </div>
            <Button
              onClick={onCancel}
              className="w-full border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 font-medium py-3 rounded-lg"
            >
              {dictionary["cancel-my-plan"][language]}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
